export function parseIndonesiaPhoneNumber(phoneNumber: string): string {
  phoneNumber = phoneNumber.replace(/\D/g, '')

  if (phoneNumber.startsWith('62')) {
    return '0' + phoneNumber.slice(2)
  }

  return phoneNumber
}
